import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreApprovalsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-approvals',
	path: '/jira/core/projects/:projectKey/settings/approvals',
	exact: true,
};
